import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Dropdown } from 'semantic-ui-react'
import $ from "jquery";
import _ from 'lodash';
import Loading from '../loading';
import Server from '../../functions/server';
import Permission from '../../functions/permission';
import Executive from './executive';
import Addmenucontrol from './add/';
import Drawer from '../drawer/drawer';
import domainName from '../../functions/domainName';
const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
});

class ButtonAppBar extends React.Component {

state = {
  load: false,
  id: '0->0',
  addmenucontrol: false,
  open: false,
  executives: [],
  load: false, menuPermission:[]
}

componentDidMount() {
  this.menuControl();
}

menuControl() {
  let menuPermission = Permission('executive-control', this.props.menus);
  this.setState({ menuPermission })
}

addExecutive() {
  if (this.state.id == 0) {
    alert('select executive');
  }
  else {
    this.setState({
      addmenucontrol: true,
    })
  }
}

getExecutiveid(value, executives) {
  this.setState({
    id: value,
    executives: executives,
    addmenucontrol: false
  })
}

handleAddOpen = () => {
  if (this.state.editmenucontrol == 'none') {
    alert('Access id Denied!!!');
    return;
  }
  else {
    if (this.state.id == '0->0') {
      alert("Please Choose Executive");
      return;
    }
    this.setState({
      open: true
    });
  }
}

handleAddClose = () => {
  this.setState({
    open: false
  });
  this.refs.child.callChildMethod();
}

handleinsert = (data) => {
  let context = this;
  context.setState({
    load: true,
    message: 'Adding menu controller!!!',
  });
  console.log(data);
  data = JSON.stringify(data);
  let id = this.state.id.split('->')[0];
  let data1 = {'data': data, 'id': id };
  $.ajax({
    type: 'POST',
    data: data1,
    url: Server() + 'menucontrol/add.php',
    success: function(data)
    {
      console.log(data);
      context.setState({
        load: false,
      })
      if (data == "1") {
        context.handleAddClose();
      }
    },
    error: function(err)
    {
      context.setState({
        load: false,
      })
    }
  })
}

logout() {
  document.cookie.split(";").forEach(function(c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
  window.location.assign(domainName());
}

render() {
  const { classes } = this.props;
  let { load, message, value,addmenucontrol } = this.state;
  let loading, addmenucontrols;
  if (load) {
    loading = (<Loading load={load} message={message} />)
  }
  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <Drawer />
          <Typography variant="h6" color="inherit" className={classes.grow}>
            Executive Control
          </Typography>
          { this.state.menuPermission.add ?
            <Button color="inherit" onClick={this.handleAddOpen}>Add</Button>: ''
          }
          <div style={{paddingLeft: '2%'}}></div>
          <Button variant="outlined" color="inherit" onClick={this.logout.bind(this)}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      { this.state.menuPermission.view ?
        (
          <div>
            <div style={{display: this.state.viewmenucontrol}}>
              <Addmenucontrol id={this.state.id} menuPermission={this.state.menuPermission}
                    open={this.state.open} executives={this.state.executives}
                    handleinsert={this.handleinsert} handleClose={this.handleAddClose}/>

              <Executive selectExecutive={this.getExecutiveid.bind(this)}
                menuPermission={this.state.menuPermission}
                newdata={this.state.newdata} viewEdit={this.state.viewEdit} ref="child" />
            </div>
            {loading}
          </div>
        ):
        (
          <div>
            <center>You are not allow to access this menu!!!</center>
          </div>
        )
      }
    </div>
  );
}
}

ButtonAppBar.propTypes = {
classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ButtonAppBar);
